import Swiper from 'swiper';

export default class Gallery {
	static init(e) {
		const galleries = e.detail.element.querySelectorAll('[data-gallery]');

		galleries.forEach((gallery) => {
			new Gallery(gallery);
		});
	}

	constructor(element) {
		this.element = element;
		const swiperElement = this.element.querySelector('[data-gallery-swiper]');

		if (!swiperElement) {
			return;
		}

		const currentIndexElement = this.element.querySelector('[data-gallery-pagination-current]');
		const prevButton = this.element.querySelector('[data-gallery-prev]');
		const nextButton = this.element.querySelector('[data-gallery-next]');
		const paginationElement = this.element.querySelector('[data-gallery-pagination]');

		this.swiper = new Swiper(swiperElement, {
			slidesPerView: 1,
			allowTouchMove: true,
			spaceBetween: 20,
			on: {
				init: (swiper) => {
					const currentIndex = swiper.realIndex + 1;
					currentIndexElement.innerHTML = `${currentIndex}`;
				},
				slideChange: (swiper) => {
					const currentIndex = swiper.realIndex + 1;
					currentIndexElement.innerHTML = `${currentIndex}`;

					paginationElement.setAttribute(
						'aria-label',
						`Gallery pagination: Slide ${currentIndex} of ${swiper.slides.length}`
					);
				},
			},
		});

		prevButton.addEventListener('click', () => {
			this.swiper.slidePrev();
		});

		nextButton.addEventListener('click', () => {
			this.swiper.slideNext();
		});

		console.log('Gallery initialized');
	}
}
